'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var PropTypes$1 = _interopDefault(require('prop-types'));
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var _babelHelpers = require('./_babelHelpers-48e7a7f7.js');
require('./settings-9ee2f03f.js');
require('./style-222d2b0f.js');
require('./typography/span.js');
var t24 = require('./typography/t24.js');
require('./buttons-color-d198c1b7.js');
var buttonIcon = require('./button/button-icon.js');

var _templateObject = _babelHelpers.taggedTemplateLiteral(["\n  display: ", ";\n"], ["\n  display: ", ";\n"]),
    _templateObject2 = _babelHelpers.taggedTemplateLiteral(["\n  display: block;\n  ", "\n  ", "\n  \n  position: fixed;\n  width: 100%;\n  height: 100%;\n  border-radius: 0px;\n  top: 0;\n  left: 0;\n  padding: 20px 20px 100px 25px;\n  z-index: 99;\n  background-color: white;\n  overflow-y: auto;\n  margin-top: 70px;\n"], ["\n  display: block;\n  ", "\n  ", "\n  \n  position: fixed;\n  width: 100%;\n  height: 100%;\n  border-radius: 0px;\n  top: 0;\n  left: 0;\n  padding: 20px 20px 100px 25px;\n  z-index: 99;\n  background-color: white;\n  overflow-y: auto;\n  margin-top: 70px;\n"]),
    _templateObject3 = _babelHelpers.taggedTemplateLiteral(["\n  display: block;\n  background-color: rgba(0, 0, 0, 0.8);\n  position: fixed;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  z-index: 20;\n"], ["\n  display: block;\n  background-color: rgba(0, 0, 0, 0.8);\n  position: fixed;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  z-index: 20;\n"]),
    _templateObject4 = _babelHelpers.taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n"], ["\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n"]),
    _templateObject5 = _babelHelpers.taggedTemplateLiteral(["\n  position: fixed;\n  padding: 20px;\n  right: 7px;\n  border-radius: 30px;\n  background-color: rgba(255, 255, 255, 0.85);\n"], ["\n  position: fixed;\n  padding: 20px;\n  right: 7px;\n  border-radius: 30px;\n  background-color: rgba(255, 255, 255, 0.85);\n"]),
    _templateObject6 = _babelHelpers.taggedTemplateLiteral(["\n  position: fixed;\n  right: 20px;\n  z-index: 99;\n"], ["\n  position: fixed;\n  right: 20px;\n  z-index: 99;\n"]);

var MobileOverlayWrapper = styled__default.div(_templateObject, function (props) {
  return props.show ? "block" : "none";
});

var MobileOverlayInnerWrapper = styled__default.div(_templateObject2, function (props) {
  return props.innerFlex && "display: flex;";
}, function (props) {
  return props.innerFlexDirection && "flex-direction: " + props.innerFlexDirection + ";";
});

var OverlayHeader = styled__default.div(_templateObject3);
var InfoHeader = styled__default.div(_templateObject4);

var ButtonIconBackground = styled__default.div(_templateObject5);

var StickyCloseButton = styled__default(buttonIcon.ButtonIcon)(_templateObject6);

var MobileInfoOverlay = function MobileInfoOverlay(_ref) {
  var showOverlay = _ref.showOverlay,
      title = _ref.title,
      children = _ref.children,
      onClickCloseButton = _ref.onClickCloseButton,
      rest = _babelHelpers.objectWithoutProperties(_ref, ["showOverlay", "title", "children", "onClickCloseButton"]);
  return React__default.createElement(
    MobileOverlayWrapper,
    { show: showOverlay },
    React__default.createElement(OverlayHeader, { onClick: onClickCloseButton }),
    React__default.createElement(
      MobileOverlayInnerWrapper,
      rest,
      React__default.createElement(
        InfoHeader,
        null,
        React__default.createElement(
          t24.default,
          null,
          title
        ),
        React__default.createElement(ButtonIconBackground, { onClick: onClickCloseButton }),
        React__default.createElement(StickyCloseButton, {
          size: "20px",
          color: "#9b9b9b",
          className: "fal fa-times",
          onClick: onClickCloseButton
        })
      ),
      children
    )
  );
};

MobileInfoOverlay.propTypes = {
  /** indicator for show overlay */
  showOverlay: PropTypes$1.bool,
  /** title of overlay info */
  title: PropTypes$1.string,
  /** function for close button */
  onClickCloseButton: PropTypes$1.func
};
MobileInfoOverlay.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "MobileInfoOverlay",
  "props": {
    "showOverlay": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "indicator for show overlay"
    },
    "title": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "title of overlay info"
    },
    "onClickCloseButton": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "function for close button"
    }
  }
};

exports.ButtonIconBackground = ButtonIconBackground;
exports.InfoHeader = InfoHeader;
exports.MobileOverlayInnerWrapper = MobileOverlayInnerWrapper;
exports.MobileOverlayWrapper = MobileOverlayWrapper;
exports.OverlayHeader = OverlayHeader;
exports.StickyCloseButton = StickyCloseButton;
exports.default = MobileInfoOverlay;
//# sourceMappingURL=mobile-info-overlay.js.map
